<template>
    <v-main  >
        <v-container
            class="fill-height"
            fluid
            dark
            :style="{'background-image': 'url(' + require('../../assets/bak3.jpg') + ')'}"
            style="background-size: cover"
        >
            <v-row
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    sm="8"
                    md="4"
                >
                    <v-col cols="12" class="text-center">
                        <img alt="Login" src="../../assets/login_img.png" style="width: 150px;">
                    </v-col>
                    <v-card class="elevation-12">
                        <v-card-text>
                            <v-col cols="12" class="text-center">Descarga tus resultados de exámenes</v-col>
                            <v-form ref="form_login">
                                <v-text-field
                                    v-model="user"
                                    label="Usuario"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    :rules=requiredRule
                                ></v-text-field>
                                <v-text-field
                                    v-model="password"
                                    label="Contraseña"
                                    prepend-icon="mdi-lock"
                                     :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="show = !show"
                                    :rules=requiredRule
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                       
                            <v-spacer></v-spacer>
                             <v-col cols="12">
                                <v-btn 
                                    color="primary" 
                                    block
                                    class="px-5"
                                    :loading="loadingBtn"
                                    @click="loginUser"
                                >
                                    <v-icon>mdi-login-variant</v-icon> Ingresar
                                </v-btn>
                             </v-col>
                             <v-row class="px-3">
                                <v-col cols="12" class="text-center">
                                    <v-btn 
                                        small 
                                        text 
                                        color="primary"
                                        link
                                        to="/recuperar_contrasena"
                                    >
                                        <v-icon>mdi-comment-question-outline</v-icon> Olvide mi contraseña
                                    </v-btn>
                                </v-col>
                                <!-- <v-col cols="12" md="6" sm="12" class="text-md-right text-sm-center ">
                                    <v-btn 
                                        small  
                                        text  
                                        color="primary"
                                        link
                                        href="#"
                                    >
                                        <v-icon>mdi-account-plus</v-icon> Registrarse
                                    </v-btn>
                                </v-col> -->
                            </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'

export default {
    name:'LoginCompnent',
    data : () => ({
        show: false,
        user:'',
        password:'',
        requiredRule:[
            v => !!v || 'El campo es requerido'
        ],
        emailRule:[
            v => !!v || 'El correo es requerido',
            v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Escriba un correo válido'
        ]
    }),
    computed:{
        ...mapState(['loadingBtn','idActionsRol'])
    },
    methods:{

        ...mapMutations(['setLoadingBtn','setUrl']),

        ...mapActions(['loginAction','requestApi','checkSessionStatus','login']),

        loginUser(){
            if(!this.$refs.form_login.validate())
                return

            this.login({
                user:this.user,
                password: this.password
            })
        }

        /* login(){

            if(!this.$refs.form_login.validate())
                return

            this.setUrl('oauth')
            this.loginAction({
                user : this.user,
                password: this.password,
            }).then(res =>{
                this.setLoadingBtn()
                if(res.statusText === "OK" && res.status === 200 && typeof res.data.access_token != "undefined"){
                    this.setLoadingBtn()
                    this.setUrl('user-laboratorio')
                    this.requestApi({
                        method:'POST',
                        data:{
                            client_id: this.user,
                            system: 'laboratorio',
                            dataBase: 'obinnoclinica',
                            comment : 'ha iniciado sesión en el sistema de consultas de examenes médicos del laboratorio'
                        }
                    })
                    .then(res=>{
                        let userString = JSON.stringify(res.data.user)
                        localStorage.setItem('user', userString)
                        this.checkSessionStatus()
                        this.setLoadingBtn()
                        typeof this.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined"
                            ? router.push('/admin_ordenes')
                            : router.push('/ordenes')
                        
                    })

                   
                }

            })
        } */

    }
}
</script>